import { getContext } from '@fiverr-private/fiverr_context';

export const getEnrichedCurrentGigUrl = ({ pathfinderWrapper, additionalQueryParams = {} }) => {
    const {
        pathParameters: { username, slug },
        queryParameters = {},
    } = getContext();

    const queryParams = {
        ...queryParameters,
        ...additionalQueryParams,
    };

    return pathfinderWrapper.pathfinder('gig_page', { username, slug }, { query: queryParams });
};
